import "./StickyHeader.scss";
import { useState, useEffect, useCallback } from "react";
import { NavLink } from "react-router-dom";
import Button from "./Button";
import jlrLogoUrl from "../../assets/imgs/home/JLR.svg";

const SCROLL_THRESHOLD_PX = 32;

const NAV_LINKS = [
	{ label: "Digital Program", to: "/", end: true },
	{ label: "Heavy Up", to: "/heavy-up-enrollment" },
	{ label: "Automated Offers", to: "/automated-offers" },
];

function Header({ enrollLink = "/enroll", enrollScrollTargetId }) {
	const [isScrolled, setIsScrolled] = useState(false);

	const onScroll = useCallback(() => {
		setIsScrolled(window.scrollY > SCROLL_THRESHOLD_PX);
	}, []);

	useEffect(() => {
		onScroll();
		window.addEventListener("scroll", onScroll, { passive: true });
		return () => window.removeEventListener("scroll", onScroll);
	}, [onScroll]);

	return (
		<header
			className={`sticky-nav ${isScrolled ? "sticky-nav--scrolled" : ""}`}
			role="banner">
			<div className="sticky-nav__inner global-padding">
				<div className="sticky-nav__brand">
					<img
						src={jlrLogoUrl}
						alt="JLR"
						className="sticky-nav__logo"
						width={31}
						height={28}
						decoding="async"
					/>
				</div>
				<nav className="sticky-nav__links" aria-label="Programs">
					{NAV_LINKS.map((link) => (
						<NavLink
							key={link.to}
							to={link.to}
							end={link.end}
							className={({ isActive }) =>
								`sticky-nav__link${isActive ? " sticky-nav__link--active" : ""}`
							}>
							{link.label}
						</NavLink>
					))}
				</nav>
				<div className="sticky-nav__cta">
					{enrollScrollTargetId ? (
						<button
							type="button"
							className="button black_button xsmall_button"
							onClick={() => {
								document
									.getElementById(enrollScrollTargetId)
									?.scrollIntoView({
										behavior: "smooth",
										block: "start",
									});
							}}>
							Enroll now
						</button>
					) : (
						<Button link={enrollLink} styleName="black" size="xsmall">
							Enroll now
						</Button>
					)}
				</div>
			</div>
		</header>
	);
}

export default Header;
